'use client'

import { ChainType } from '@polaris/core/models'
import type { ReactNode } from 'react'
import { CosmosProvider } from '@/src/ecosystems/cosmos/provider'
import { EvmProvider } from '@/src/ecosystems/evm/provider'
import { SolanaProvider } from '@/src/ecosystems/solana/provider'
import type { EcosystemsServerContext } from './ecosystems-context'

interface EcosystemProvidersProps {
  children: ReactNode
  context: EcosystemsServerContext
}

export function EcosystemProviders({
  children,
  context,
}: EcosystemProvidersProps) {
  return (
    <SolanaProvider>
      <CosmosProvider quirksCookie={context[ChainType.Cosmos]?.value}>
        <EvmProvider initialState={context[ChainType.Evm]}>
          {children}
        </EvmProvider>
      </CosmosProvider>
    </SolanaProvider>
  )
}
